import React from 'react';
import './App.scss';
import { ChooChoo } from '@express-labs/raven-choo-choo';
import HeaderV2 from './components/HeaderV2';

function App() {
  return (
    <div className="raven-header" id="headerContainer">
      <div id="global-banner-container">
        <ChooChoo
          mode="uid"
          value="blt3922b9222857d3b1"
          contentType="global_banner"
        />
      </div>
      <HeaderV2 />
    </div>
  );
}

export default App;
